export const INTEGRATION_VENDORS = {
  ecr: "ecr",
  github: "github",
  gitlab: "gitlab",
  webhook: "webhook",
  azure: "azure_repos",
  bitbucket: "bitbucket",
  jira: "jira",
  packageRegistry: "package_registry",
  dockerHub: "docker_hub",
  gcr: "gcr",
  acr: "acr",
  slack: "slack",
  azureBoards: "azure_boards",
  asana: "asana"
} as const
